import './App.css';
import Header from "./Header/Header";
import Section from "./Section/Section";
import FAQDropdownMenu from "./FAQDropDownMenu/FAQDropDownMenu";
import Footer from "./Footer/Footer";
import FAQ from "./FAQ/FAQ";
import React from "react";


function App() {
    return (
        <div className="App">
            <Header/>
            <Section/>
            <FAQ/>
            {/*<FAQDropdownMenu/>*/}
            <Footer/>
        </div>
    );
}

export default App;
